/**
 * @generated SignedSource<<94828a5a5166da15374d9009e359ce26>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ApiExplorerSync_query$data = {
  readonly apiExplorer: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly value: string;
      };
    }>;
  };
  readonly " $fragmentType": "ApiExplorerSync_query";
};
export type ApiExplorerSync_query$key = {
  readonly " $data"?: ApiExplorerSync_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"ApiExplorerSync_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ApiExplorerSync_query",
  "selections": [
    {
      "alias": "apiExplorer",
      "args": [
        {
          "kind": "Literal",
          "name": "filterElement",
          "value": {
            "single": {
              "name": "name",
              "operator": "equals",
              "value": "api_explorer"
            }
          }
        }
      ],
      "concreteType": "UserDataConnection",
      "kind": "LinkedField",
      "name": "userData",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "UserDataEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "UserData",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "value",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "userData(filterElement:{\"single\":{\"name\":\"name\",\"operator\":\"equals\",\"value\":\"api_explorer\"}})"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "1932d88ef11b690ef67aaa635a3c7d42";

export default node;
